<template lang="pug">
  form.feature-update(@submit.prevent="upsertTag")
    .form-field
      .form-field-with-label(:class="{ disabled: feature.isReadOnly }")
        label
          h6 Tag
          .merge-search
            input(type="text", placeholder="Search", v-debounce="search", v-model="filters.text", :disabled="feature.isReadOnly")
            .merge-search-results(v-if="showResults")
              .item(v-for="result in results", @click="addTag(result)")
                .feature
                  .feature-name
                    h5 {{ result.tag }}
            .no-search-results(v-if="noResults")
              p Create "{{filters.text}}"

</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'FeatureTag',
  components: {
  },
  props: {
    board: Object
  },
  data () {
    return {
      filters: {
        text: ''
      },
      results: []
    }
  },
  computed: {
    ...mapState({
      feature: state => state.features.selected,
      tags: state => state.tags
    }),
    showResults () {
      return this.filters.text.length > 0 && this.results.length > 0
    },
    noResults () {
      return this.filters.text.length > 0 && this.results.length === 0
    }
  },
  methods: {
    search () {
      //console.log(filter)
      //console.log(this.filters.text)
      this.results = this.tags.filter(tag => (tag.tag.toLowerCase().indexOf(this.filters.text.toLowerCase()) > -1))

      //console.log(this.results)
    },
    clear () {
      this.filters.text = ''
    },
    upsertTag () {
      this.$store.dispatch('addTags', this.filters.text)
        .then(this.addTag)
    },
    addTag (tag) {
      let updates = {
        slug: this.feature.slug,
        update: {
          tags: [...this.feature.tags.map(tag => (tag._id)), tag._id]
        }
      }
      //console.log('update', updates)
      this.$store.dispatch('features/updateFeature', updates)
      this.$emit('addTag', tag)
      this.clear()
    }
  }
}
</script>

<style scoped lang="stylus">
.form-field-with-label
  padding 0
  h6
    padding $spacing $spacing 0 $spacing
.merge-search
  position relative
  input[type="text"]
    padding 0 $spacing $spacing $spacing
  .merge-search-results
    background-color #fff
    border $border-default
    border-radius $border-radius
    box-shadow 0 6px 12px rgba(0,0,0,0.175)
    position absolute
    margin-top 5px
    //height 100px
    width 100%
    z-index 100
    .item
      border-bottom $border-default
      padding $spacing
      &:last-child
        border-bottom none
  .no-search-results
    background-color #fff
    border $border-default
    border-radius $border-radius
    box-shadow 0 6px 12px rgba(0,0,0,0.175)
    padding $spacing
    position absolute
    margin-top 5px
    //height 100px
    text-align center
    width 100%
    z-index 100

  .feature-name
    margin-bottom 5px
  .feature-stats
    font-size $text-size-smaller
    display flex
    .feature-stat
      //border $border-default
      margin-right $spacing
      //padding 2px
      .icon
        margin-right 5px
</style>
